/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableOpacity, TouchableHighlight } from 'react-native'
import styles from './Styles/SectionHeaderStyle'
import I18n from "i18n-js"

export default class SectionHeaderFollow extends Component {

  render() {
    let followingText = I18n.t('followersProfile.followingLC') 
    return (
      <View style={[styles.container,this.props.containerStyle, 
                   {backgroundColor: (this.props.text === followingText ? '#FFFFFF' : '#000000')},
                   {borderColor: '#000000', borderRadius : 5, borderWidth : 1}
                   ]}>
        <TouchableOpacity style = {{ flex : 1, width : '100%', height : '100%', justifyContent : 'center', alignItems : 'center' }}
         disabled={this.props.disabled} onPress={this.props.onPress}>
          <Text style={[styles.text, this.props.style, {color: (this.props.text === followingText ? '#000000' : '#FFFFFF')},
                        ]}>{this.props.text}</Text>
        </TouchableOpacity>
      </View>
    )
  }
}
